import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import images from '../../../Utils/images';
import colors from '../../../Utils/colors';
import CheerioButton from '../../../Components/CheerioButton';
import {
    useEdgesState,
    useNodesState,
    Node,
    Edge
} from 'reactflow';
import { getAllWfLibTemplates } from "../../../Services/index"
import { useNavigate, useParams } from 'react-router-dom'
import './TemplatePreview.scss'
import WorkflowPreview from './workflowPreviewComponent'
import { industriesData } from "../../../Utils/workflowLibraryUtils";
import SpinnerLoader from '../../../Components/SpinnerLoader';
import {eventsend} from '../../../Config/analyticsFunctions'
type IndustryItem = {
    source?: any;
    icon?: string;
    sTitle: string;
};

const initialNodes: Node[] = [];

const WorkflowTemplatePreview = () => {

    const navigate = useNavigate();
    const authtoken = useSelector((state: any) => state.main.auth_token);
    const localdata = useSelector((state: any) => state.main.localdata);
    const { id } = useParams<{ id: string }>();
    const [workflowName, setWorkflowName] = useState('');
    const [description, setDescription] = useState('');
    const [tagName, setTagName] = useState('');
    const [createdBy, setCreatedBy] = useState('');
    const [category, setCategory] = useState('');
    const [updatedAt, setUpdatedAt] = useState('');
    const [workflowJourney, setWorkflowJourney] = useState('');
    const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
    const [edges, setEdges, onEdgesChange] = useEdgesState<Edge[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getAllWfLibTemplatesList = async () => {
        setIsLoading(true);
        try {
            const res = await getAllWfLibTemplates(authtoken, id ?? "");

            if (res?.flag && res?.data) {
                setTagName(res?.data?.nodes?.[0]?.type ?? "");
                setWorkflowName(res?.data?.name ?? "");
                setDescription(res?.data?.description ?? "");
                setCreatedBy(res?.data?.authorName ?? "");
                setCategory(res?.data?.category ?? "");
                setUpdatedAt(
                    res?.data?.updatedAt
                        ? new Date(res?.data?.updatedAt).toLocaleString()
                        : "N/A"
                );
                setWorkflowJourney(res?.data?.workflowJourney ?? "");
                setNodes(res?.data?.nodes ?? []);
                setEdges(res?.data?.edges ?? []);
            } else {
                console.warn("No template details found for id:", id, res);
            }
        } catch (err) {
            console.error("Error fetching template preview:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getAllWfLibTemplatesList();
    }, [id]);

    const renderIndustryTag = (tag: string) => {
        const normalizedTag = tag?.trim() ?? "";
        const industry: IndustryItem | undefined =
            industriesData?.[normalizedTag]?.[0];

        if (!industry) return null;

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.25rem",
                    padding: "0.25rem 0.375rem",
                    borderRadius: "1.25rem",
                    border: `1px solid ${colors.greys03}`,
                    backgroundColor: colors.white01,
                    width: "fit-content",
                    flexShrink: 0,
                }}
            >
                {industry?.source && (
                    <img
                        src={industry?.source}
                        alt={""}
                        style={{
                            height: "1.125rem",
                            width: "1.125rem",
                            objectFit: "contain",
                        }}
                    />
                )}
                <p
                    style={{
                        fontSize: "0.75rem",
                        color: colors.black,
                        margin: 0,
                        whiteSpace: "nowrap",
                    }}
                >
                    {industry?.sTitle ?? ""}
                </p>
            </div>
        );
    };


    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: "100vh",
                width: "100vw",
                overflow: 'hidden',
                backgroundColor: colors.white01,
                position: 'relative'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: "1.3rem 4rem",
                    borderBottom: `1px solid ${colors.borderwhite}`,
                    backgroundColor: colors.white01,
                    flexShrink: 0,
                    minHeight: "60px"
                }}
            >
                <img
                    src={images.BackArrowBlack}
                    style={{
                        height: "1.25rem",
                        width: "1.25rem",
                        objectFit: 'contain',
                        cursor: 'pointer',
                        marginRight: "0.75rem",
                        flexShrink: 0
                    }}
                    onClick={() => {
                        navigate(-1)
                    }}
                />
                <h3 style={{
                    fontSize: "1.125rem",
                    fontWeight: 600,
                    margin: 0,
                    lineHeight: 1.2
                }}>
                    Back to templates
                </h3>
            </div>

            {isLoading ? (
                <>
                    <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                        <SpinnerLoader />
                    </div>
                </>
            ) : (
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'minmax(300px, 35%) 1fr',
                        height: 'calc(100vh - 60px)',
                        overflow: 'hidden',
                        gap: 0,
                    }}
                >
                    <div style={{
                        padding: '1rem 1.5rem 1rem 4rem',
                        backgroundColor: colors.white01,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem',
                        overflow: 'auto',
                        minWidth: 0,

                    }}>
                        {renderIndustryTag(tagName)}

                        <h2 style={{
                            fontSize: "clamp(1.25rem, 3vw, 1.75rem)",
                            fontWeight: 700,
                            margin: 0,
                            lineHeight: 1.2,
                            wordBreak: "break-word"
                        }}>
                            {workflowName || ""}
                        </h2>

                        <p style={{
                            fontSize: "clamp(0.875rem, 1.8vw, 1rem)",
                            fontWeight: 400,
                            color: "#666666",
                            margin: 0,
                            lineHeight: '1.5',
                            wordBreak: "break-word",
                            marginBottom: '0.5rem'
                        }}>
                            {description || ""}
                        </p>

                        <div style={{ marginBottom: '1rem' }}>
                            <CheerioButton
                                borderStyle={{
                                    border: `1px solid ${colors.darkPurple}`,
                                }}
                                textStyle={{
                                    color: colors.white02,
                                    fontSize: "0.875rem"
                                }}
                                btnText={'Use flow'}
                                backColor={colors.darkPurple}
                                onclick={() => {
                                    navigate('../../workflow', {
                                        state: {
                                            nodes, edges,
                                            isFromTemplate: true
                                        },
                                    });
                                    eventsend('workflow_library_template_used', {
                                        timestamp: new Date().toISOString(),
                                        account_id: localdata?.id,
                                        workflowTemplateName: workflowName ?? "",
                                        creator_type: "System",
                                        category: category ?? ""
                                    })
                                }}
                                icon={null}
                                id="send-report-btn"
                            />
                        </div>

                        <div
                            className="flex-row justify-content-start align-items-start w-100"
                            style={{
                                marginBlockStart: 8,
                                display: "flex",
                                flexWrap: "wrap",
                                paddingInline: 5,
                            }}
                        >
                            {(() => {
                                try {
                                    if (!Array.isArray(nodes) || nodes.length === 0) {
                                        return (
                                            <p style={{ fontSize: 12, color: "#888" }}>No nodes to display</p>
                                        );
                                    }

                                    const seenTypes = new Set<string>();

                                    return nodes
                                        .filter((node: any) => {
                                            if (!node?.type) return false;
                                            if (seenTypes.has(node.type)) return false;
                                            seenTypes.add(node.type);
                                            return true;
                                        })
                                        .map((node: any) => {
                                            const icon = nodeTypeIcons[node.type as NodeType];
                                            if (!icon) return null;

                                            return (
                                                <div
                                                    key={node.id}
                                                    className="d-flex flex-column align-items-center"
                                                    style={{ width: 60 }}
                                                >
                                                    <div
                                                        className="d-flex justify-content-center align-items-center"
                                                        style={{
                                                            height: 50,
                                                            width: 50,
                                                            borderRadius: 10,
                                                            background: icon.bg,
                                                        }}
                                                    >
                                                        <img
                                                            src={icon.src}
                                                            alt={icon.label}
                                                            style={{ height: 28, width: 28, objectFit: "contain" }}
                                                        />
                                                    </div>
                                                    <p
                                                        style={{
                                                            margin: 0,
                                                            marginTop: 4,
                                                            fontSize: 10,
                                                            fontWeight: 600,
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {icon.label}
                                                    </p>
                                                </div>
                                            );
                                        });
                                } catch (err) {
                                    console.error("Error rendering nodes:", err);
                                    return (
                                        <p style={{ color: "red", fontSize: 12 }}>
                                            Failed to load nodes. Please try again.
                                        </p>
                                    );
                                }
                            })()}
                        </div>




                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem'
                        }}>
                            <div>
                                <p style={{
                                    fontSize: "0.75rem",
                                    fontWeight: 400,
                                    margin: 0,
                                    color: "#666666",
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Created by
                                </p>
                                <p style={{
                                    fontSize: "0.875rem",
                                    fontWeight: 700,
                                    margin: 0,
                                    marginTop: '0.25rem',
                                    wordBreak: "break-word"
                                }}>
                                    {createdBy || ""}
                                </p>
                            </div>

                            <div>
                                <p style={{
                                    fontSize: "0.75rem",
                                    fontWeight: 400,
                                    margin: 0,
                                    color: "#666666",
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Category
                                </p>
                                <p style={{
                                    fontSize: "0.875rem",
                                    fontWeight: 700,
                                    margin: 0,
                                    marginTop: '0.25rem',
                                    wordBreak: "break-word"
                                }}>
                                    {category || ""}
                                </p>
                            </div>

                            <div>
                                <p style={{
                                    fontSize: "0.75rem",
                                    fontWeight: 400,
                                    margin: 0,
                                    color: "#666666",
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Updated on
                                </p>
                                <p style={{
                                    fontSize: "0.875rem",
                                    fontWeight: 700,
                                    margin: 0,
                                    marginTop: '0.25rem',
                                    wordBreak: "break-word"
                                }}>
                                    {updatedAt || ""}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        overflow: 'hidden',
                        padding: '1rem 4rem 1rem 1rem',
                        gap: '1rem',
                        minWidth: 0
                    }}>
                        <div style={{
                            border: `1px solid ${colors.borderwhite}`,
                            borderRadius: "0.75rem",
                            backgroundColor: colors.white01,
                            overflow: "hidden",
                            position: "relative",
                            height: '50dvh',

                        }}>
                            <WorkflowPreview
                                nodes={nodes ?? []}
                                edges={edges ?? []}
                                onEdgesChange={onEdgesChange}
                                onNodesChange={onNodesChange}
                            />
                        </div>

                        <div style={{
                            flexShrink: 0,
                            backgroundColor: colors.white01,
                            padding: "1rem",
                            borderRadius: "0.75rem",
                            overflow: 'auto',
                            width: "100%",
                            height: '30dvh',

                        }}>
                            <h4 style={{
                                fontSize: "1rem",
                                fontWeight: 600,
                                margin: 0,
                                marginBottom: '0.75rem',
                                color: colors.black
                            }}>
                                Description
                            </h4>
                            <p style={{
                                fontSize: "0.875rem",
                                fontWeight: 400,
                                margin: 0,
                                lineHeight: '1.5',
                                color: "#000000",
                                wordBreak: "break-word"
                            }}>
                                {description || ""}
                            </p>
                            <h4 style={{
                                fontSize: "1rem",
                                fontWeight: 600,
                                margin: "1rem 0 0.75rem 0",
                                color: colors.black
                            }}>
                                Workflow Journey
                            </h4>
                            <p style={{
                                fontSize: "0.875rem",
                                fontWeight: 400,
                                margin: 0,
                                lineHeight: '1.5',
                                color: "#000000",
                                wordBreak: "break-word",
                                whiteSpace: "pre-line"
                            }}>
                                {workflowJourney || ""}
                            </p>

                        </div>
                    </div>

                </div>
            )}
        </div>
    )
}

export default WorkflowTemplatePreview;


export type NodeType =
    | "incomingWA"
    | "campaign"
    | "condition"
    | "codeNode"
    | "responseMessage"
    | "shopify"
    | "facebookLead"
    | "contactWFNode"
    | "wooWFNode"
    | "pabblyEvent"
    | "kylasCreate"
    | "kylasUpdate"
    | "incomingWebhook"
    | "formsWFNode"
    | "instagramEvent"

    | "sendWATemplate"
    | "feedbackNode"
    | "sendEmail"
    | "instagramAction"
    | "metaPixelNode"
    | "updateShopifyAttributes"
    | "assignAIAssistant"
    | "chatgpt"
    | "catalog"
    | "whatsAppPayment"
    | "assignAgent"
    | "updateChatStatus"
    | "timeDelay"
    | "attributeCondition"
    | "llama"
    | "addToLabel"
    | "updateAttribute"
    | "webhookTrigger"
    | "endNode"
    | "updateBroadcast";


export const nodeTypeIcons: Record<
    NodeType,
    { src: string; bg?: string; label: string }
> = {
    campaign: { src: images.WFAnnounce, bg: "#3200C1", label: "Campaign Sent" },
    incomingWA: { src: images.WFWhatsApp, bg: colors.success03, label: "Incoming WhatsApp" },
    shopify: { src: images.ShopifyWhite, bg: "#004D1F", label: "Shopify Events" },
    facebookLead: { src: images.FacebookWhite, bg: "#1877F2", label: "Facebook Lead" },
    contactWFNode: { src: images.CONTACT_ICON, bg: "#530FE3", label: "New Contact" },
    wooWFNode: { src: images.WOOIMG, bg: "#7B50C6", label: "Commerce Event" },
    pabblyEvent: { src: images.WFPabbly, bg: "#22B376", label: "Pabbly Event" },
    kylasCreate: { src: images.KylasWorkflow, bg: "#0176FF", label: "Kylas Event Create" },
    kylasUpdate: { src: images.KylasWorkflow, bg: "#0176FF", label: "Kylas Event Update" },
    incomingWebhook: { src: images.WEBHOOK_TRIGGER, bg: "#009684", label: "Incoming Webhook" },
    formsWFNode: { src: images.WFForm, bg: "#8E53F7", label: "New form response" },
    instagramEvent: { src: images.WFInstagram, bg: "linear-gradient(45deg,#F58529,#DD2A7B,#8134AF,#515BD4)", label: "Instagram", },
    // 🔹 Action nodes
    responseMessage: { src: images.WFResponse, bg: colors.success03, label: "Response message" },
    sendWATemplate: { src: images.WFWhatsApp, bg: colors.success03, label: "Send WA template" },
    feedbackNode: { src: images.WFFeedback, bg: "#FAC300", label: "Feedback Collection" },
    sendEmail: { src: images.WFEmail, bg: "#FF4D4D", label: "Send Email" },
    instagramAction: { src: images.WFResponse, bg: "linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)", label: "Instagram Action", },
    metaPixelNode: { src: images.PIXEL_EVENT, bg: "#0064E1", label: "Meta Pixel" },
    updateShopifyAttributes: { src: images.ShopifyWhite, bg: "#004D1F", label: "Shopify Actions" },
    assignAIAssistant: { src: images.AIAssistantIcon, bg: "#FF9900", label: "Assign AI Assistant" },
    chatgpt: { src: images.WFGpt, bg: "#14B38B", label: "Assign GPT" },
    catalog: { src: images.Book, bg: colors.success03, label: "Send WA Catalog" },
    whatsAppPayment: { src: images.PaymentReceipt, bg: "#B752C7", label: "Payment Message" },
    assignAgent: { src: images.WFAgent, bg: "#FF7C32", label: "Assign Agent" },
    updateChatStatus: { src: images.WFChatStatus, bg: "#30D3C0", label: "Update Chat Status" },
    timeDelay: { src: images.WFTime, bg: colors.blue03, label: "Time delay" },
    attributeCondition: { src: images.WFAT, bg: colors.error03, label: "Attribute condition" },
    condition: { src: images.WFAT, bg: colors.error03, label: "Set a condition" },
    codeNode: { src: images.WFCode, bg: "#7D52FF", label: "Custom Code" },
    llama: { src: images.WFLlama, bg: "#DBEEF5", label: "Llama" },
    addToLabel: { src: images.Label, bg: "#14B38B", label: "Add to Label" },
    updateAttribute: { src: images.Tag, bg: "#6430D3", label: "Update Attribute" },
    webhookTrigger: { src: images.WEBHOOK_TRIGGER, bg: colors.error03, label: "Webhook Trigger" },
    endNode: { src: images.WFEnd, bg: "#C10808", label: "End Flow" },
    updateBroadcast: { src: images.BROADCAST_ICON, bg: "#18C655", label: "Update Broadcast" },
};